// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SketchCircleFilledSvg from "@ant-design/icons-svg/es/asn/SketchCircleFilled";
import AntdIcon from '../components/AntdIcon';

var SketchCircleFilled = function SketchCircleFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SketchCircleFilledSvg
  }));
};

SketchCircleFilled.displayName = 'SketchCircleFilled';
export default React.forwardRef(SketchCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/SketchCircleFilled.js
// module id = 1805
// module chunks = 0